import React, {memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

interface TileCardBrandNameProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    $singleLineBrandName?: boolean
    $marginBottom?: boolean
    children: string
}

export const TileCardBrandName = memo(
    ({templating, $singleLineBrandName, $marginBottom, children}: TileCardBrandNameProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        return (
            <ComponentName $singleLineBrandName={$singleLineBrandName} $marginBottom={$marginBottom}>
                {children}
            </ComponentName>
        )
    },
)
TileCardBrandName.displayName = "TileCardBrandName"

export default connect(TileCardBrandName)
